import qs from 'query-string';
import { get } from './baseApi';

export const BreedApi = {
    fetch: (query) => get(`/breeds?${qs.stringify(query)}`),
};
